import {Tooltips}    from './tooltips';
import {MatchHeight} from './match-height';
import {FileUpload}  from './file-upload';
import {MenuOpen}    from './menu-open';
import {MenuScroll}  from './menu-scroll';
import { LightGallery } from 'vue-light-gallery';

//Vue components
import Vue               from 'vue';
import VueTinySlider     from 'vue-tiny-slider';
import VueTabs           from './components/VueTabs';
import VueGeolocation    from 'vue-browser-geolocation';
import VueLazyload       from 'vue-lazyload';
import VueYoutubeWrapper from './components/VueYoutube';
import VueReadMore       from './components/VueReadMore';
import VueReference      from './components/VueReference';
import VueYoutube        from 'vue-youtube';
import InquiryForm       from './components/Inquiry/Form';
import {scrollToElement} from './mixins/scrollToElement';

Vue.use(VueGeolocation);
Vue.use(VueLazyload);
Vue.use(VueYoutube);
Vue.directive('scrollTo', scrollToElement);
Vue.component('read-more', VueReadMore);
Vue.component('reference', VueReference);


export class App {

	constructor() {
		this.matchHeight = {selector: ''};
		this.tooltips    = {
			selector: '',
			id:       ''
		};
		// this.sideContainer = {selector: ''};
	}

	initVue() {
		new Vue({
			el: '#app',

			components: {
				'tiny-slider':     VueTinySlider,
				'tabs':            VueTabs,
				'inquiry-form':    InquiryForm,
				'youtube-wrapper': VueYoutubeWrapper,
				'light-gallery' : LightGallery
			},

			data: {
				headerFixed: false,
				menuActiveTab: 77,
				indexSlider: null,
				referencesGallery: [
					{ index: null},
					{ index: null},
					{ index: null},
				],
				galleryOpen: false,
				ourServices:   {
					0:   {
						items: 1.2
					},
					767: {
						autoWidth: false,
						items:     3
					},
					998: {
						disable: true
					}
				},
				whyGo:         {
					0:   {
						items:  1.2,
						gutter: 17
					},
					768: {
						items:  3,
						gutter: 32
					},
					998: {
						items: 4
					}
				},
				clients:       {
					0:   {
						items: 2
					},
					768: {
						items: 4
					}
				},
				services:      {
					0:   {
						items: 1
					},
					768: {
						gutter: 16,
						items:  2
					},
					992: {
						gutter: 32
					}
				},
				tabUrl:        ''
			},

			methods: {
				getClickTabs(id, url) {
					this.activeTab       = id;
					window.location.hash = url;
				},

				clickedMenuTabs(value, event) {
					const mediaQueryList = window.matchMedia(' (min-width: 768px) ');

					const resizes = (mediaQueryList) => {
						if(mediaQueryList.matches) {
							event.preventDefault();
							this.menuActiveTab = value;
						}
					};

					resizes(mediaQueryList);
					mediaQueryList.addListener(resizes);
				},
			},

			computed: {
				isMobileResize () {
					const mediaQueryList = window.matchMedia(' (max-width: 768px) ');

					const resizes = (mediaQueryList) => {
						return mediaQueryList.matches;
					};

					return resizes(mediaQueryList);
					// mediaQueryList.addListener(resizes);
				}
			},
		});
	}

	// Same height initialization
	initSameHeight() {
		const matchHeight = new MatchHeight(this.matchHeight.selector);
		matchHeight.init();
	}

	// Tooltips initialization
	initTooltips() {
		const tooltips = new Tooltips(this.tooltips.selector, this.tooltips.id);
		tooltips.init();
	}

	// Side container initialization
	initSideContainer() {
		const sideContainer = new SideContainer(this.sideContainer.selector);
		sideContainer.init();
	}

	initFileUpload() {
		const fileUpload = new FileUpload();
	}

	initMenuOpen() {
		let header = document.querySelector('header[role="banner"]');

		if(header) {
			const menuOpen = new MenuOpen(header);
		}
	}

	initScrollMenu() {
		let header = document.querySelector('header[role="banner"]');

		if(header) {
			const scrollMenu = new MenuScroll(header);
		}
	}

	init() {
		this.initVue();
		this.initSameHeight();
		this.initTooltips();
		// this.initSideContainer();
		this.initFileUpload();
		this.initMenuOpen();
		this.initScrollMenu();
	}
}
